import React from "react";

import Breadcrumbs from "components/molecules/breadcrumbs/index.jsx";
import Badge from "components/atoms/badge/index.jsx";
import { currency, getDiscountAmount } from "helpers/format.js";

import "./styles.scss";

const FormHero = ({ vehicle, action = "reservando", promotion }) => {
  return (
    <div className="formHero">
      <Breadcrumbs type="over" vehicle={vehicle} />
      <div className="container">
        <div className="verticalCenter">
          <div className="col">
            <h4>Estas {action}:</h4>
            <h2>
              {vehicle.brand} {vehicle.name}
            </h2>
            <Badge type="inverted" style="big">
              {currency(
                vehicle.full_price - getDiscountAmount(vehicle, promotion)
              )}
              {promotion && (
                <span>
                  - {currency(getDiscountAmount(vehicle, promotion))} de
                  descuento
                </span>
              )}
            </Badge>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormHero;
